import { fromJS } from 'immutable'
import {
  LEAVE_ENTITLEMENT_DELETE_REQUEST,
  LEAVE_ENTITLEMENT_DELETE_SUCCESS,
  LEAVE_ENTITLEMENT_DELETE_FAILURE,
  LEAVE_ENTITLEMENT_DELETE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_ENTITLEMENT_DELETE_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_ENTITLEMENT_DELETE_SUCCESS:
      return state
        .set('deletedLeaveEntitlement', fromJS(action.payload.deletedLeaveEntitlement))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_DELETE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_ENTITLEMENT_DELETE_RESET:
      return state
        .delete('deletedLeaveEntitlement')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/leave-entitlement-delete-reducer.js